import {createAction} from 'Shared/utilities/actionCreator';
import {ETLAggregateStatus} from 'SystemAdministration/models/ETLStatus';
import {Async, Empty, Loading} from 'Core/models/Async';

export enum ETLDashboardActionType {
  GET_ETL_STATUSES = 'etlDashboard/GET_ETL_STATUSES',
  LOAD_ETL_STATUSES = 'etlDashboard/LOAD_ETL_STATUSES',
}

export const getETLStatuses = () => createAction(ETLDashboardActionType.GET_ETL_STATUSES);
export const loadETLStatuses = (etlStatuses: Async<ETLAggregateStatus>) =>
  createAction(ETLDashboardActionType.LOAD_ETL_STATUSES, {etlStatuses});

type ETLDashboardState = Async<ETLAggregateStatus>;
const DEFAULT_STATE = new Empty();

type ETLDashboardAction = ReturnType<typeof getETLStatuses> | ReturnType<typeof loadETLStatuses>;

export default (state: ETLDashboardState = DEFAULT_STATE, action: ETLDashboardAction): ETLDashboardState => {
  switch (action.type) {
    case ETLDashboardActionType.GET_ETL_STATUSES:
      return new Loading();
    case ETLDashboardActionType.LOAD_ETL_STATUSES:
      return action.payload.etlStatuses;
    default:
      return state;
  }
};
